import { LayoutGrid } from 'lucide-react';

export function ArtifactLayoutEngineV3Panel({ data }) {
  const entries = data?.layout_entries || [];

  if (!data) return null;

  return (
    <div className="space-y-4">
      <div className="rounded-xl border border-emerald-500/25 bg-emerald-950/15 p-4 flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-2 text-sm text-emerald-200">
          <LayoutGrid className="w-4 h-4" />
          {data.total_layout_entries} Layout Engine entries
          {data.step === '5C.4' ? (
            <span className="text-[10px] text-emerald-400/70">(Step 5C.4)</span>
          ) : null}
        </div>
        <div className="text-sm text-slate-400">
          Auto layout · edge routing · React Flow positions
        </div>
      </div>

      <div className="rounded-lg border border-slate-700/60 bg-slate-900/40 p-3 text-[11px] text-slate-400 font-mono space-y-1">
        <p>5C.3 Studio → <span className="text-emerald-300">5C.4 Layout Engine</span> → SVG Renderer</p>
        <p>API: POST layout/preview · POST layout/apply · GET layout/types</p>
        <p>Engines: {(data.engines || []).join(' · ')}</p>
        <p>Layout types: {(data.layout_types || []).join(' · ')}</p>
      </div>

      {entries.length ? (
        <ul className="space-y-1">
          {entries.map((e) => (
            <li
              key={e.artifact_id}
              className="rounded-lg border border-emerald-500/20 bg-emerald-950/10 px-3 py-2 text-sm text-emerald-100"
            >
              <span className="font-mono text-[11px] text-emerald-400/90">{e.artifact_id}</span>
              <span className="mx-2 text-slate-500">·</span>
              <span className="truncate">{e.name}</span>
              <span className="text-[10px] text-slate-500 ml-2">v{e.current_version}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-slate-500">No layout entries yet.</p>
      )}
    </div>
  );
}
